import { Form, Formik } from "formik";
import ModalComponent from "../../../components/common-components/modal/ModalComponent";
import Button from "../../../components/common-components/button/Button";
import Input from "../../../components/common-components/input/Input";
import LimitReachedPopup from "./LimitReachedPopup";
import { FORM_FIELDS_NAMES } from "./Constants";
import { useDispatch, useSelector } from "react-redux";
import { setClearOtpOrMobile, setStartTimer, componentKey } from "../../../pages/Patients/AddPatient/AddPatientSlice";
import { useEffect, useState, useRef } from "react";
import Label from "../../../components/common-components/label/Label";
import { BUTTON_VARIANTS } from "../../../components/common-components/button/Constants";
import { linkMobileRequest, linkMobileValidate} from "../../../pages/Patients/AddPatient/AddPatientSaga";

const ValidateMobileModal = ({ open, close }) => {
	const [showErrorText, setShowErrorText] = useState({ show: false });
	const { transactionIdAndAadhaar, startTimer, mobileNumberToLink, createPatientFromAadhaar } = useSelector((state) => state[componentKey]);
	const [timer, setTimer] = useState(60);
	const [resendDisabled, setResendDisabled] = useState(true);
	const [resendLimit, setResendLimit] = useState(3);
	const [showResendLimitPopup, setShowResendLimitPopup] = useState(false);
	const [otp, setOtp] = useState("");
	const dispatch = useDispatch();
	const intervalRef = useRef(null);

	useEffect(() => {
		return () => {
			if (intervalRef.current) clearInterval(intervalRef.current);
		};
	}, []);

	const handleSendOTP = () => {
		dispatch(setClearOtpOrMobile(false));
		if (resendLimit > 0) {
			setResendLimit(prevState => prevState - 1);
			setTimer(60);
			setResendDisabled(true);
			dispatch(setStartTimer(true));
			const payload = {
				loginId: mobileNumberToLink, 
				"xtoken": createPatientFromAadhaar?.patient?.xtoken, 
				"loginHint":"mobile"
			}
			dispatch(linkMobileRequest(payload));
			if (intervalRef.current) clearInterval(intervalRef.current);
			intervalRef.current = setInterval(() => {
				setTimer(prev => {
					if (prev <= 1) {
						clearInterval(intervalRef.current);
						intervalRef.current = null;
						setResendDisabled(false);
						dispatch(setStartTimer(false));
						return 0;
					}
					return prev - 1;
				});
			}, 1000);
		} else {
			setShowResendLimitPopup(true);
		}
	};

	const validateValues = (values) => {
		console.log(values)
		if (otp.length !== 6) return { status: false, message: "Invalid OTP" };
		if (!/^[6-9]\d{9}$/.test(values[FORM_FIELDS_NAMES.MOBILE_NUMBER]) || values[FORM_FIELDS_NAMES.MOBILE_NUMBER].length !== 10)
			return { status: false, message: "Mobile number must be 10 digits and start with 6-9" };
		return { status: true };
	};

	const formatTime = (time) => {
		const minutes = Math.floor(time / 60).toString().padStart(2, '0');
		const seconds = (time % 60).toString().padStart(2, '0');
		return `${minutes}:${seconds}`;
	};

	return (
		<>
			<Formik
				initialValues={{
					[FORM_FIELDS_NAMES.MOBILE_NUMBER]: mobileNumberToLink,
					[FORM_FIELDS_NAMES.OTP]: '',
				}}
				enableReinitialize
				onSubmit={(values) => {
					dispatch(setClearOtpOrMobile(false));
					
					const fieldsValidation = validateValues(values);
					try {
						if (!fieldsValidation.status) {
							setShowErrorText({
								show: true,
								message: fieldsValidation.message
							});
							return;
						} else {
							setShowErrorText({ show: false });
						}
                        let payload = {
						otp:otp,
						txnId:transactionIdAndAadhaar.transactionId,
						xtoken: createPatientFromAadhaar?.patient?.xtoken,
						loginHint:'mobile',
						loginId: mobileNumberToLink
					}
					dispatch(linkMobileValidate({otpVerificationData:payload, isNew:createPatientFromAadhaar?.patient?.isNew}));
					} catch (error) {
						console.log("Error", error);
					}
				}}
			>
				{({ submitForm, isSubmitting, handleReset, values, handleSubmit, setFieldValue, handleBlur, ...props }) => {
					return (<>
					<Form onSubmit={handleSubmit}>
							<div>
								<ModalComponent
									open={open}
									close={close}
									title={'Verify Mobile'}
									footerButton={
										<div className={`${showErrorText?.show ? "w-full flex items-center justify-between" : ""}`}>
											{showErrorText?.show && <Label asteriskPosition="start" color="red-500" fontSize="sm">* {showErrorText?.message}</Label>}
											<div className='flex gap-2.5'>
												<Button
													type="button"
													variant={BUTTON_VARIANTS.CONTAINED}
													customBtnClass={`text-met-primary ${resendDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
													onClickCb={() => handleSendOTP()}
													disabled={resendDisabled}
												>
													Resend OTP
												</Button>
												<Button
													type="submit"
													variant={BUTTON_VARIANTS.CONTAINED}
													customBtnClass={`text-met-primary ${otp.length !== 6 ? 'opacity-50 cursor-not-allowed' : ''}`}
													disabled={otp.length !== 6}
												>
													Submit
												</Button>
											</div>
										</div>
									}
									customClasses="w-[800px]"
								>
									<div className="p-2">
										<div className="flex column-gap-10px items-center pt-6">
											<div className="flex-1">
												<div className="flex justify-between items-end gap-2">
													<Input
														label="Mobile Number"
														placeholder="Please enter 10 digits Mobile Number"
														isRequired={true}
														name={FORM_FIELDS_NAMES.MOBILE_NUMBER}
														value={mobileNumberToLink}
														onBlurCb={handleBlur}
														maxLength={10}
														disabled={true}
													/>
													<Button
														type="button"
														variant={BUTTON_VARIANTS.CONTAINED}
														customBtnClass={`text-met-primary w-fit text-nowrap mb-1 ${resendLimit !== 3 ? 'opacity-50 cursor-not-allowed' : ''}`}
														onClickCb={() => handleSendOTP()}
														disabled={resendLimit !== 3}
													>
														Send OTP
													</Button>
												</div>
												<div>
													<Input
														label="OTP"
														placeholder="Please enter 6 digits OTP"
														isRequired={true}
														name={"otp"}
														value={otp}
														onChangeCb={(e) => {
															setShowErrorText(null);
															const numericValue = e.target.value.replace(/[^0-9]/g, '');
															if (numericValue.length <= 6) {
																setOtp(numericValue);
															}
														}}
														onBlurCb={handleBlur}
														disabled={resendLimit === 3}
													/>
												</div>
												{startTimer && resendLimit!==3 &&(
													<div className="text-left pt-2 text-sm">
														Resend in {formatTime(timer)}
													</div>
												)}
												<div className="text-left pt-2 text-sm">
													{resendLimit}/3 OTP Request remaining
												</div>
											</div>
										</div>
									</div>
								</ModalComponent>
							</div>
						</Form>
					</>		
					);
				}}
			</Formik>
			{showResendLimitPopup &&
				<LimitReachedPopup
					open={showResendLimitPopup}
					close={() => {
						setShowResendLimitPopup(false);
						close();
					}}
				/>
			}
		</>
	);
};

export default ValidateMobileModal;
